<template>
  <div>
    <headline-container headline="Images" :breadcrumbs="[{text: 'Images'}]">
      <a href="#create-image-modal" class="btn btn-white" data-toggle="modal">
        <i class="fa fa-plus"></i> Create
      </a>
    </headline-container>

    <loading-container v-if="loading"></loading-container>

    <div v-else class="container">
      <div class="panel panel-default">
        <div class="panel-body">
          <form @submit.prevent="submitSearch">
            <div class="row">
              <div class="col-md-18">
                <div class="form-group">
                  <input
                      v-model="currentSearch"
                      type="text"
                      class="form-control input-sm"
                      placeholder="Search..."
                  >
                </div>
              </div>

              <div class="col-md-6">
                <button type="submit" class="btn btn-default btn-block btn-black btn-sm">
                  <i class="fa fa-filter"></i> Filter
                </button>
              </div>
            </div>
          </form>

          <div v-for="chunk in chunks" class="row" style="margin-bottom: 14px">
            <div v-for="image in chunk" class="col-xs-6">
              <div style="position: relative; cursor: pointer;" @click.prevent="edit(image)">
                <img
                    :src="'/images/crop-400x400/' + image.id + '.' + image.attributes.extension"
                    style="max-width: 100%;"
                    :alt="image.attributes.title"
                />

                <div style="position: absolute; top: 0; left: 0; background-color: #000000; opacity: 0.7; width: 100%; color: #ffffff; padding: 6px;">
                  {{ image.attributes.title }}
                </div>
              </div>
            </div>
          </div>

          <simple-pager :current-page="page" :last-page="images.meta.last_page" @navigate="navigate"/>
        </div>
      </div>
    </div>

    <create-modal @created="load"/>

    <edit-modal id="edit-image-modal" :image="editing" @updated="update" @deleted="load"/>
  </div>
</template>

<script>
import http from '@/http'
import CreateModal from '@/components/Modals/Administration/Images/Create'
import EditModal from '@/components/Modals/Administration/Images/Edit'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LoadingContainer from '@/components/Layout/LoadingContainer'
import Permissions from '@/mixins/Permissions'
import SimplePager from '@/components/Lists/SimplePager'

export default {
  components: {CreateModal, EditModal, HeadlineContainer, LoadingContainer, SimplePager},

  mixins: [Permissions],

  data() {
    return {
      page: 1,
      images: null,
      loading: true,
      editing: null,

      search: '',
      currentSearch: ''
    }
  },

  mounted() {
    this.load()
  },

  computed: {
    chunks() {
      let result = []

      for (let i = 0; i < this.images.data.length; i += 4) {
        result.push(this.images.data.slice(i, i + 4))
      }

      return result
    }
  },

  methods: {
    load() {
      this.loading = true

      http.get('/api/v2/images', {'filter[search]': this.search, page_size: 16, page: this.page})
          .then(response => {
            this.images = response.data

            this.loading = false
          })
    },

    edit(image) {
      this.editing = image

      $('#edit-image-modal').modal({backdrop: 'static'}, 'show')
    },

    update(image) {
      this.images.data.splice(this.images.data.findIndex(existing => existing.id === image.id), 1, image)
    },

    submitSearch() {
      this.search = this.currentSearch

      this.navigate(1)
    },

    navigate(page) {
      this.page = page

      this.load()
    }
  }
}
</script>
